// ui/floating/FloatingPanel.tsx
import styled from "styled-components";

export const FloatingPanel = styled.div<{ $open: boolean }>`
  position: absolute;
  bottom: 72px; /* ⬅ button height + spacing */
  right: 0;

  width: 380px;

  transform: ${({ $open }) =>
    $open ? "translateY(0)" : "translateY(16px)"};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  pointer-events: ${({ $open }) => ($open ? "auto" : "none")};
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: ${({ theme }) => theme.shadow.md};
  border-radius: ${({ theme }) => theme.radius.md};
  padding: ${({ theme }) => theme.spacing(2)};

  transition: all 0.25s ease;
`;
